import { createSelector, createFeatureSelector } from '@ngrx/store';
import { AppState } from './app-state.reducer';

// Create a feature selector to get the app state
export const selectAppState = createFeatureSelector<AppState>('app');

// Selector for selectedApplication
export const selectSelectedApplication = createSelector(
  selectAppState,
  (state: AppState) => state.selectedApplication
);


// Selector for current user (email + name from JWT)
export const selectCurrentUser = createSelector(
  selectAppState,
  (state: AppState) => state.currentUser
);

// Selector for current User Email (derived — kept for back-compat)
export const selectCurrentUserEmail = createSelector(
  selectCurrentUser,
  (user) => user?.email ?? null
);

// Selector for current User Name (display name from JWT)
export const selectCurrentUserName = createSelector(
  selectCurrentUser,
  (user) => user?.name ?? null
);

// Selector for selectedApplication
export const selectSelectedAppDetails = createSelector(
  selectAppState,
  (state: AppState) => state.selectedAppDetails
);

// Selector for appList
export const selectAppList = createSelector(
  selectAppState,
  (state: AppState) => state.appList
);

// Selector for current user's role in the selected application
export const selectCurrentUserRole = createSelector(
  selectAppState,
  (state: AppState) => {
    if (!state.selectedApplication || !state.appList) {
      return null;
    }
    const app = state.appList.find(app => app.applicationId === state.selectedApplication);
    return app ? app.userType : null;
  }
);

// Composed selector: full user identity joining JWT data with appList membership.
// Returns null until both the JWT user is set and the appList has loaded.
export const selectCurrentUserProfile = createSelector(
  selectCurrentUser,
  selectAppState,
  (user, state) => {
    if (!user) return null;
    const membership = state.appList?.find(
      app => app.applicationId === state.selectedApplication && app.email === user.email
    );
    return {
      email: user.email,
      name: user.name,
      userId: membership?.userId ?? null,
      userName: membership?.userName ?? null,
      userType: membership?.userType ?? null
    };
  }
);
